import { get, post } from '../../axios/axios';
import { guestHeaders } from '../../Service/guest';

/** 展示用价格（元 / 篇），实际金额以下单接口返回为准 */
export const FORMAT_PRICES = { normal: 99, rush: 129.9 };

export const ACCEPT_EXTENSIONS = ['doc', 'docx', 'pdf'];

export const MAX_FILE_MB = 30;

const unwrap = (res, fallback = '请求失败，请稍后重试') => {
    if (res && res.code === 0) return res.data;
    throw new Error(res?.msg || fallback);
};

export const errorText = (error, fallback) => {
    if (error?.response?.status === 413) return `文件过大，请上传不超过 ${MAX_FILE_MB}MB 的文件`;
    if (error?.response?.data?.msg) return error.response.data.msg;
    if (error?.code === 'ECONNABORTED') return '上传超时，请检查网络后重试';
    if (!error?.response && error?.message === 'Network Error') return '网络异常，请检查网络后重试';
    return error?.message || fallback;
};

/**
 * 提交格式精修订单（免登录，multipart），返回 { orderNo, payNo, price, rush }。
 * 价格由服务端按普通 / 加急决定。
 */
export const createFormatOrder = async ({ file, schoolName, rush, remark, contact }, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    form.append('schoolName', schoolName);
    form.append('rush', rush ? 'true' : 'false');
    if (remark) form.append('remark', remark);
    if (contact) form.append('contact', contact);
    const res = await post('/ai/format/order', form, {
        headers: guestHeaders(),
        timeout: 300000,
        slient: true,
        onUploadProgress: (event) => {
            if (!onProgress || !event?.total) return;
            onProgress(Math.min(99, Math.round((event.loaded / event.total) * 100)));
        },
    });
    return unwrap(res, '提交订单失败，请重试');
};

/** 订单状态：{ orderNo, status(0 待支付 / 1 已支付 / 2 已交付), paid, price, rush } */
export const getFormatOrder = async (orderNo) =>
    unwrap(await get(`/ai/format/order/${encodeURIComponent(orderNo)}`, {}, { slient: true }));

// ---------- 本机记住最近一笔订单（关闭页面 / 手机端跳转付款后回来仍能找到客服入口） ----------

const LAST_ORDER_KEY = 'lgfb.formatter.lastOrder';

export const rememberOrder = (order) => {
    try {
        if (!order) {
            window.localStorage.removeItem(LAST_ORDER_KEY);
            return;
        }
        window.localStorage.setItem(LAST_ORDER_KEY, JSON.stringify({ ...order, savedAt: Date.now() }));
    } catch {
        // 本地存储不可用时忽略
    }
};

export const rememberedOrder = () => {
    try {
        const order = JSON.parse(window.localStorage.getItem(LAST_ORDER_KEY) || 'null');
        return order && typeof order.orderNo === 'string' ? order : null;
    } catch {
        return null;
    }
};

// ---------- 杂项 ----------

export const formatYuan = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num.toFixed(2) : '--';
};

export const formatSize = (bytes) => {
    const num = Number(bytes);
    if (!Number.isFinite(num) || num <= 0) return '';
    if (num < 1024 * 1024) return `${Math.max(1, Math.round(num / 1024))} KB`;
    return `${(num / 1024 / 1024).toFixed(1)} MB`;
};

export const fileExtension = (name) => {
    const value = String(name || '');
    const dot = value.lastIndexOf('.');
    return dot < 0 ? '' : value.slice(dot + 1).toLowerCase();
};

export const isMobileUa = () =>
    typeof navigator !== 'undefined' &&
    /android|iphone|ipod|windows phone|mobile/i.test(navigator.userAgent);

export const copyText = async (text, message) => {
    try {
        await navigator.clipboard.writeText(text);
        message?.success('订单号已复制');
    } catch {
        message?.info(`请手动复制订单号：${text}`);
    }
};
